import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/api';

function PageHeader({ title, subtitle, backButton, onBack, backTitle, backTo, backLabel, actionButton, sticky, onSettings }) {
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    apiFetch('/api/company-settings')
      .then(res => res.json())
      .then(data => {
        if (data && data.company_name) {
          setCompanyName(data.company_name);
        }
      })
      .catch(() => {
        const savedName = localStorage.getItem('companyName');
        if (savedName) setCompanyName(savedName);
      });
  }, []);

  return (
    <div
      className={`bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-md ${sticky ? 'sticky top-0 z-10' : ''}`}
      style={{ height: '116px' }}
    >
      <div className="max-w-full mx-auto px-6 h-full flex flex-col justify-between py-3">
        {/* Company Name - Top Left */}
        {companyName && (
          <div className="text-white text-sm font-medium opacity-90">
            {companyName}
          </div>
        )}

        {/* Main Title Area */}
        <div className="flex items-center justify-between flex-1">
          {(backButton || backTo) && (
            <button
              onClick={backTo ? () => navigate(backTo) : onBack}
              className="text-white hover:text-blue-100 transition text-lg font-semibold"
              title={backLabel || backTitle}
            >
              {backLabel || backTitle || 'Back'}
            </button>
          )}
          <div className={`${(backButton || backTo) || actionButton || onSettings ? 'flex-1' : 'w-full'} text-center`}>
            <h1 className="text-4xl font-bold">{title}</h1>
            {subtitle && <span className="text-sm text-blue-100">{subtitle}</span>}
          </div>
          {actionButton ? actionButton : (
            <div className="flex items-center gap-2">
              {onSettings && (
                <button
                  onClick={onSettings}
                  title="Settings"
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-blue-800 transition"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </button>
              )}
              {(backButton || backTo) && <div style={{ width: '40px' }}></div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
